import React from "react";

import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import { Carousel as BaseCarousel } from "../Carousel/Carousel";
import { SKSArrows } from "./Arrows";
import { SKSDots } from "./Dots";

import styles from "./index.module.scss";

type Props = React.ComponentProps<typeof BaseCarousel> & {
    dotsClassName?: string;
    controlsClassName?: string;
};

/**
 * SKS-branded carousel with default arrows and dots.
 *
 * At the time of creation, this module is intended to be more of a parts bin
 * for the actual carousels. There will probably be no good reason to import
 * this component directly, but it'll be useful to share bits like arrows
 * and dots.
 */
export function Carousel(props: Props) {
    return (
        <BaseCarousel
            {...props}
            containerProps={{
                ...props.containerProps,
                className: concatClassNames([
                    props.containerProps?.className,
                    styles.root,
                ]),
            }}
            scrollContainerProps={{
                ...props.scrollContainerProps,
                className: concatClassNames([
                    props.scrollContainerProps?.className,
                    styles.scrollContainer,
                ]),
            }}
            controls={
                "controls" in props
                    ? props.controls
                    : ({ allVisible }) => (
                          <SKSArrows
                              allVisible={allVisible}
                              className={props.controlsClassName}
                          />
                      )
            }
            dots={
                "dots" in props
                    ? props.dots
                    : (dotProps) => (
                          <SKSDots
                              {...dotProps}
                              className={props.dotsClassName}
                          />
                      )
            }
            loop={"loop" in props ? props.loop : false}
        />
    );
}
